import { BrandMark } from './BrandMark';

type Props = { size?: number };

export const BrandWordmark = ({ size = 18 }: Props) => (
  <span className="brand" style={{ fontSize: size, gap: 9, display: 'inline-flex', alignItems: 'center' }}>
    <BrandMark size={Math.round(size * 1.5)} />
    <span style={{ fontWeight: 600, letterSpacing: '-0.02em' }}>
      Cana<span style={{ color: 'var(--primary)' }}>Biz</span>
    </span>
  </span>
);
